import { UsuarioDistribuidorRepository } from "../repository/usuario_distribuidor_repository";

export class UsuarioDistribuidorService {
	constructor() {
		this.usuarioDistribuidorRepository = new UsuarioDistribuidorRepository();
	}

	async save(data) {
		return await this.usuarioDistribuidorRepository.save(data);
	}

	async update(data) {
		return await this.usuarioDistribuidorRepository.update(data);
	}

	async getAll(unidadeDistribuidoraId, page, limit, search, ativo) {
		return await this.usuarioDistribuidorRepository.getAll(unidadeDistribuidoraId, page, limit, search, ativo);
	}

	async getById(id) {
		return await this.usuarioDistribuidorRepository.getById(id);
	}

	async toggleStatus(id) {
		return await this.usuarioDistribuidorRepository.toggleStatus(id);
	}
}
